/**
 * MARIO BADESCU TÜRKİYE - FINAL LOCALIZED GLOBAL JS
 * Sanitized for Zero-Leak Data Isolation & Sovereign Infrastructure.
 */

// 1. UI BRAIN: Quotes / Testimonials
class QuotesViewer extends HTMLElement {
  constructor() {
    super();
    this.logos = this.querySelectorAll('.logo-img'); 
    this.quotes = this.querySelectorAll('.quote-text-container .quote-item');
    if(window.innerWidth > 750)
      this.logos.forEach(tab => tab.addEventListener('click', this.handleLogoOnClick.bind(this)));
  }
  handleLogoOnClick (e) {
    e.preventDefault(); e.stopPropagation();
    const step = (e.currentTarget.dataset.index || 1) - 1;
    this.quotes.forEach((q,i) => { if(i !== step) q.classList.remove('active') });
    this.logos.forEach((l,i) => l.classList.remove('active'));
    e.currentTarget.classList.add('active');
    this.quotes[step].classList.add("active");
  }
}
customElements.define('quotes-viewer', QuotesViewer);

// 2. UI BRAIN: Navigation & Scroll
class GoToTopButton extends HTMLElement {
  constructor() {
    super();
    this.anchor = this.querySelector("a");
    window.addEventListener("scroll", () => {
      this.anchor.style.display = window.scrollY > window.screen.height / 2 ? "block" : "none";
    });
  }
}
customElements.define('go-to-top-button', GoToTopButton);

// 3. UI BRAIN: Countdown Timer (Localized Labels)
Date.prototype.addHours = function(h) { this.setTime(this.getTime() + (h*60*60*1000)); return this; }
class CountDownTimer extends HTMLElement {
  constructor() {
    super();
    this.dateInput = this.querySelector("input#timer_time");
    this.daylightOffsetInput = this.querySelector("input#timer_savings");
    this.timerContainer = this.querySelector("span.announcement-bar__timer");
    this.holidayStyle = this.querySelector("input#timer_holiday").value === 'true';

    let initialDate = new Date(this.dateInput.value);
    let hourOffset = parseInt(this.daylightOffsetInput.value) - initialDate.getTimezoneOffset() / 60;

    const x = setInterval(() => {
      let now = new Date(); now.addHours(-1 * hourOffset);
      let distance = initialDate.getTime() - now.getTime();
      if (distance < 0) { clearInterval(x); return; }

      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.timerContainer.innerHTML = this.holidayStyle 
        ? `<span class="c-days c-square"><span class="num">${days}</span><span class="txt">GÜN</span></span><span class="c-hours c-square"><span class="num">${hours}</span><span class="txt">SAAT</span></span><span class="c-minutes c-square"><span class="num">${minutes}</span><span class="txt">DAK</span></span><span class="c-seconds c-square"><span class="num">${seconds}</span><span class="txt">SN</span></span>`
        : `${days > 0 ? days + "g : " : ""}${hours > 0 ? hours + "s : " : ""}${minutes}d : ${seconds}s`;
    }, 1000);
  }
}
customElements.define('countdown-timer', CountDownTimer);

// 4. DATA ISOLATION: Localized Back-in-Stock (Klaviyo TR)
function openNotifyMePopup(notifyFormId) {
    const KLAVIYO_ACCOUNT_ID = 'YOUR_TR_KLAVIYO_ID'; 

    if (KLAVIYO_ACCOUNT_ID === 'YOUR_TR_KLAVIYO_ID') {
        alert("Sistem şu an yapılandırılıyor. Lütfen daha sonra tekrar deneyiniz.");
        return;
    }

    const customerEmail = prompt("Bu ürün stoklara geldiğinde haber almak ister misiniz?\nLütfen e-posta adresinizi giriniz:", "");

    if (customerEmail && customerEmail.includes("@")) {
        fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                'a': KLAVIYO_ACCOUNT_ID,
                'email': customerEmail,
                'variant': notifyFormId,
                'platform': 'shopify'
            })
        })
        .then(() => { alert("Teşekkür ederiz! Ürün stoklarımıza girdiğinde size e-posta göndereceğiz."); })
        .catch(() => { alert("Bir hata oluştu. Lütfen tekrar deneyiniz."); });
    } else if (customerEmail !== null) {
        alert("Lütfen geçerli bir e-posta adresi giriniz.");
    }
}

// 5. LOCAL BRAIN: Cart Progress & Video
class CartTotalProgressBar extends HTMLElement {
  constructor() {
    super();
    const totalElem = this.querySelector("#cart-total");
    const threshElem = this.querySelector("#shipping-treshhold");
    if(!totalElem || !threshElem) return;

    const cartVal = parseFloat(totalElem.value) / (Shopify.currency.rate || 1);
    const shipVal = parseFloat(threshElem.value);
    let percent = Math.min(100, Math.max(0, (cartVal / shipVal) * 100));
    this.querySelector(".free-shipping").style.setProperty("--treshold-percentage", percent + "%");
  }
}
customElements.define("cart-total-progress-bar", CartTotalProgressBar);

class ExpandContent extends HTMLElement {
  constructor() {
    super();
    this.expandElement = document.querySelector(this.dataset.expandElement);
    this.anchor = this.querySelector("a");
    this.anchor.addEventListener("click", (e) => {
      e.preventDefault();
      this.expandElement.removeAttribute("hidden");
      this.anchor.style.display = "none";
    });
  }
}
customElements.define("expand-content", ExpandContent);

function reloadCartDrawer() {
  let cart = document.querySelector('cart-drawer');
  if (!cart) return;
  fetch(`${window.location.origin}?sections=cart-drawer`)
    .then(res => res.json())
    .then(response => {
      let sectionElem = document.querySelector("#CartDrawer");
      if(sectionElem) sectionElem.innerHTML = response["cart-drawer"];
    });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(".card-wrapper").forEach(card => {
    card.addEventListener("mouseenter", e => {
      let video = e.target.querySelector("video");
      if(video) video.load();
    });
  });
});